import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StorybookAssignmentService {

  messageStore: BehaviorSubject<string>;

  constructor(private http: HttpClient) { }

  getAllStorybookAssignemntsByStudentID(studentId:string){
    return this.http.get(environment.BACKEND_HOST + environment.BACKEND_STORYBOOK_ASSIGNMENT_ENDPOINT + "?studentId=" + studentId)
  }

  saveNewStorybookAssignment(formData: FormData){
    console.log(formData.get("storybookId"));
    return this.http.post(
      environment.BACKEND_HOST + environment.BACKEND_STORYBOOK_ASSIGNMENT_ENDPOINT, 
      formData, 
      {responseType:'text'});
  }
}
